/* unplugin-vue-components disabled */import { render } from "./BugFill.vue.js?vue&type=template&id=2c522c82!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./BugFill.vue?vue&type=template&id=2c522c82"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__